import React, { useEffect, useState } from 'react'
import { Typography } from 'antd'
import { CheckOutlined } from '@ant-design/icons'

import VtLogo from '../../../assets/images/logo-purple.svg'
import IntlMessages from '../../../util/IntlMessages'
import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'

const { Paragraph } = Typography

const CompletePlanTrial = (): React.ReactElement => {
  const [plan, setPlan] = useState<SubscriptionPlanEnum>(SubscriptionPlanEnum.complete)

  useEffect(() => {
    const selectedPlanFromStorage = localStorage.getItem('vtSubscriptionPlan') as SubscriptionPlanEnum | null

    if (
      selectedPlanFromStorage
      && [SubscriptionPlanEnum.freemium, SubscriptionPlanEnum.core, SubscriptionPlanEnum.complete].includes(selectedPlanFromStorage)
    ) {
      setPlan(selectedPlanFromStorage)
    }
  }, [])


  return (
    <div className="content-plan-trial">
      <VtLogo style={{ width: '240px' }} />
      <h3>{
        plan === SubscriptionPlanEnum.freemium
          ? <span><IntlMessages id="createCompany.freeForever" /></span>
          : (
            <>
              <span><IntlMessages id="createCompany.completePlanTrial.days" /></span> <IntlMessages id="createCompany.completePlanTrial.title" values={{ plan }} />
            </>
          )
      }</h3>
      {plan === SubscriptionPlanEnum.complete && 
        <Paragraph className="subtitle"><IntlMessages id="createCompany.completePlanTrial.subtitle" /></Paragraph>
      }
      {plan === SubscriptionPlanEnum.core && 
        <Paragraph className="subtitle"><IntlMessages id="createCompany.corePlanTrial.subtitle" /></Paragraph>
      }
      {plan === SubscriptionPlanEnum.freemium && <>
        <Paragraph className="subtitle"><IntlMessages id="createCompany.freemiumPlan.subtitle" /></Paragraph>
        <Paragraph className="check-mark"><CheckOutlined /> <IntlMessages id="createCompany.completePlanTrial.item1" /></Paragraph>
        <Paragraph className="check-mark"><CheckOutlined /> <IntlMessages id="createCompany.completePlanTrial.item2" /></Paragraph>
        <Paragraph className="check-mark"><CheckOutlined /> <IntlMessages id="createCompany.completePlanTrial.item3" /></Paragraph>
      </>}
      { plan === SubscriptionPlanEnum.complete && <>
        <Paragraph className="check-mark"><CheckOutlined /> <IntlMessages id="createCompany.completePlanTrial.item1" /></Paragraph>
        <Paragraph className="check-mark"><CheckOutlined /> <IntlMessages id="createCompany.completePlanTrial.item2" /></Paragraph>
        <Paragraph className="check-mark"><CheckOutlined /> <IntlMessages id="createCompany.completePlanTrial.item3" /></Paragraph>
      </>}
    </div>
  )
}

export default CompletePlanTrial
